/* ==========================================================================
   zenz-mobile.js - mobilraffinering for Zenzorama (2026-08-06)

   Tre uavhengige deler, alle progressive forbedringer:
     A. Scroll-reveal for [data-zm-reveal] / [data-zm-reveal-group]
     B. Kompakt mobilheader som skjules ved tydelig nedoverscroll
     C. Kontekstavhengig flytende mobil-CTA

   Ingen biblioteker. Én rAF-strupet scroll-lytter deles av B og C, saa vi
   aldri har to lyttere som konkurrerer om samme frame.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__zenzMobileInit) return;
  window.__zenzMobileInit = true;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var MOBILE_MAX = 989;

  var isMobile = function () {
    return window.innerWidth <= MOBILE_MAX;
  };

  /* ======================================================================
     A. Scroll-reveal
     ====================================================================== */

  var revealObserver = null;

  function initReveal() {
    // Redusert bevegelse eller manglende IO: la innholdet staa synlig.
    // `.zm-anim` settes ikke, saa CSS-en som nuller opacity slaar aldri inn.
    if (reduced || !hasIO) return;

    document.documentElement.classList.add('zm-anim');

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          // `boundingClientRect.top < 0` fanger elementer som allerede var
          // scrollet forbi ved lasting (f.eks. ved anker-navigasjon).
          if (en.isIntersecting || en.boundingClientRect.top < 0) {
            en.target.classList.add('is-zm-in');
            revealObserver.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    observeReveals(document);

    // Sikkerhetsnett: avsloer alt etter 1,5 s uansett. Transitions stopper i
    // skjulte faner og i headless-render - uten dette kan en seksjon bli
    // staaende blank i et skjermbilde eller hos en crawler.
    setTimeout(function () {
      document
        .querySelectorAll('[data-zm-reveal]:not(.is-zm-in),[data-zm-reveal-group]:not(.is-zm-in)')
        .forEach(function (el) {
          el.classList.add('is-zm-in');
        });
    }, 1500);
  }

  function observeReveals(scope) {
    if (!revealObserver) return;
    scope.querySelectorAll('[data-zm-reveal],[data-zm-reveal-group]').forEach(function (el) {
      if (!el.classList.contains('is-zm-in')) revealObserver.observe(el);
    });
  }

  /* ======================================================================
     B. Kompakt mobilheader
     ====================================================================== */

  var header = document.querySelector('[data-zenz-mega-header]');

  // Elementet som faktisk er festet, er seksjonswrapperen - ikke <header>
  // (se forklaringen i zenz-mobile.css punkt 3). Skjul/vis-klassen maa
  // derfor settes paa wrapperen, ellers transformerer vi et element som
  // scroller bort av seg selv.
  var pinEl = header ? header.closest('.shopify-section-group-header-group') || header : null;

  // Hysterese: smaa rykk skal ikke veksle klassen. Vi akkumulerer bevegelse
  // i én retning og bytter foerst naar terskelen er passert.
  var HIDE_AFTER = 12; // px sammenhengende nedover foer headeren skjules
  var SHOW_AFTER = 6; // px oppover er nok til aa hente den tilbake
  var COMPACT_AT = 80;

  var lastY = window.scrollY || 0;
  var accumDown = 0;
  var accumUp = 0;
  var headerHidden = false;
  var headerFloor = 0; // hvor langt ned man maa vaere foer skjuling er lov

  function measureHeader() {
    headerFloor = pinEl ? pinEl.offsetHeight + 40 : 120;
  }

  function showHeader() {
    if (!pinEl) return;
    pinEl.classList.remove('zm-header-hidden');
    headerHidden = false;
  }

  function updateHeader(y) {
    if (!pinEl) return;

    if (!isMobile()) {
      showHeader();
      if (header) header.classList.remove('zm-header-compact');
      return;
    }

    // Mobilmeny/soek aapen: la headeren staa. CSS nuller transformen ogsaa,
    // men vi holder klassen ren slik at den ikke "spretter" ved lukking.
    if (document.documentElement.classList.contains('zh-no-scroll')) {
      showHeader();
      return;
    }

    if (header) header.classList.toggle('zm-header-compact', y > COMPACT_AT);

    // Over toppomraadet: alltid synlig.
    if (y <= headerFloor) {
      showHeader();
      return;
    }

    var delta = y - lastY;

    if (delta > 0) {
      accumDown += delta;
      accumUp = 0;
      if (accumDown > HIDE_AFTER && !headerHidden) {
        pinEl.classList.add('zm-header-hidden');
        headerHidden = true;
      }
    } else if (delta < 0) {
      accumUp -= delta;
      accumDown = 0;
      if (accumUp > SHOW_AFTER && headerHidden) {
        showHeader();
      }
    }
  }

  /* ======================================================================
     C. Flytende mobil-CTA
     ====================================================================== */

  var cta = document.querySelector('[data-zm-cta]');
  var heroEl = null;
  var heroBottom = 0;
  var footerInView = false;
  var ctaVisible = false;

  function findHero() {
    var sel = [
      '[data-zm-hero]',
      '.zhx-hero',
      '.ztj-hero',
      '.zenz-hero',
      '.zap-hero',
      '.zfe__hero',
      '.section-image-with-text-overlay',
    ].join(',');
    heroEl = document.querySelector(sel);
    measureHero();
  }

  function measureHero() {
    if (heroEl) {
      var r = heroEl.getBoundingClientRect();
      heroBottom = r.top + (window.scrollY || 0) + r.height;
    } else {
      // Ingen identifiserbar hero: bruk foerste skjermhoyde som terskel.
      heroBottom = window.innerHeight * 0.8;
    }
  }

  function updateCta(y) {
    if (!cta) return;

    if (!isMobile()) {
      if (ctaVisible) {
        cta.classList.remove('is-zm-visible');
        ctaVisible = false;
      }
      return;
    }

    // Vis naar heroens underkant har passert midten av skjermen.
    var passedHero = y + window.innerHeight * 0.5 > heroBottom;
    var shouldShow = passedHero && !footerInView;

    if (shouldShow !== ctaVisible) {
      cta.classList.toggle('is-zm-visible', shouldShow);
      ctaVisible = shouldShow;
    }
  }

  function initFooterWatch() {
    if (!cta || !hasIO) return;
    var footer =
      document.querySelector('[data-zm-footer]') ||
      document.querySelector('.zf') ||
      document.querySelector('#shopify-section-footer-group') ||
      document.querySelector('footer');
    if (!footer) return;

    new IntersectionObserver(
      function (entries) {
        footerInView = entries[0].isIntersecting;
        updateCta(window.scrollY || 0);
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    ).observe(footer);
  }

  /*
    PROVD OG FORKASTET 2026-08-06: aa skjule pillen naar en av sidens egne
    «Få pristilbud»-knapper var i viewporten. Maalt paa /pages/tjenester,
    som har 8 slike lenker: pillen var synlig 24 % av scrolldybden og slo
    av og paa i moensteret 0-1-0-0-0-1-1-0-0-1-0... Blafringen var verre enn
    dobbeltoppfordringen den skulle loese. En flytende CTA maa vaere
    forutsigbar for aa vaere til nytte.

    Gjentakelsen av «Få pristilbud» paa tjenestesiden staar igjen som et
    redaksjonelt spoersmaal, ikke noe JS skal skjule.
  */

  // Tastatur / aapent skjema: CTA-en skal ikke ligge oppaa et felt man
  // skriver i, og skal ikke bli dyttet opp av tastaturet paa iOS.
  function initKeyboardWatch() {
    if (!cta) return;

    var FIELD = 'input:not([type=hidden]):not([type=submit]):not([type=button]),textarea,select';

    document.addEventListener(
      'focusin',
      function (e) {
        if (e.target.matches && e.target.matches(FIELD)) {
          document.body.classList.add('zm-keyboard-open');
        }
      },
      true
    );

    document.addEventListener(
      'focusout',
      function () {
        // Kort utsettelse: fokus kan flytte seg mellom to felt i samme skjema.
        setTimeout(function () {
          var a = document.activeElement;
          if (!a || !(a.matches && a.matches(FIELD))) {
            document.body.classList.remove('zm-keyboard-open');
          }
        }, 60);
      },
      true
    );

    // visualViewport krymper naar det virtuelle tastaturet aapnes. Dekker
    // tilfellet der fokus ligger i en iframe (f.eks. innbygde skjemaer).
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        var shrunk = window.visualViewport.height < window.innerHeight * 0.75;
        document.body.classList.toggle('zm-keyboard-open', shrunk);
      });
    }
  }

  /* ======================================================================
     Delt scroll-loop
     ====================================================================== */

  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      // iOS rubber-band gir negativ scrollY og verdier over maks - klem dem,
      // ellers tolkes gummistrikken som retningsskifte og headeren blafrer.
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (y < 0) y = 0;
      if (y > max) y = max;

      updateHeader(y);
      updateCta(y);

      lastY = y;
      ticking = false;
    });
  }

  function onResize() {
    measureHeader();
    measureHero();
    updateHeader(window.scrollY || 0);
    updateCta(window.scrollY || 0);
  }

  /* ======================================================================
     Oppstart
     ====================================================================== */

  function boot() {
    initReveal();
    measureHeader();
    findHero();
    initFooterWatch();
    initKeyboardWatch();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', debounceLocal(onResize, 150), { passive: true });
    window.addEventListener('orientationchange', function () {
      setTimeout(onResize, 250);
    });

    // Bilder som laster inn endrer heroens hoyde - mål om igjen naar siden
    // er ferdig lastet.
    window.addEventListener('load', onResize);

    onScroll();
  }

  function debounceLocal(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: seksjoner rendres om uten sidelasting.
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
    header = document.querySelector('[data-zenz-mega-header]') || header;
    if (header) {
      pinEl = header.closest('.shopify-section-group-header-group') || header;
    }
    cta = document.querySelector('[data-zm-cta]') || cta;
    findHero();
    onResize();
  });
})();
